import { render, staticRenderFns } from "./CommunicationLog.vue?vue&type=template&id=e79096ee&scoped=true&"
import script from "./CommunicationLog.vue?vue&type=script&lang=js&"
export * from "./CommunicationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79096ee",
  null
  
)

export default component.exports